<div>
    <div class="user-profile-detail user-order-detail order-short-detail scrollbar " *ngIf="!orderForm">
        <div class="right-icon d-lg-none d-flex">
            <a (click)="backClick()"><img src="assets/images/right-arrow-user.svg" alt="icon"></a>
        </div>
        <div>
            <div *ngIf="this.mOrderDetailListData && this.mOrderDetailListData.length > 0;">
                <div class="order-detail-box" *ngFor="let mOrderDetail of  this.mOrderDetailListData">
                    <div *ngIf="mOrderDetail && mOrderDetail.product_detail && mOrderDetail.product_detail.length < 2">
                        <div class="order-status-and-number">
                            <div class="order-number-and-placed">
                                <div class="order-number">
                                    <label>Order Number</label>
                                    <span>{{mOrderDetail.order_number}}</span>
                                </div>
                            </div>
                            <div class="order-place">
                                <label>Placed</label>
                                <span>{{showDate(mOrderDetail?.order_date)}}</span>
                            </div>
                            <div class="order-status">
                                <label>Order Status</label>
                                <span *ngIf="mOrderDetail?.order_status == 'cancel'" class="c-orange">Cancelled</span>
                                <span *ngIf="mOrderDetail?.order_status != 'cancel'" class="c-orange">{{mOrderDetail?.order_status}}</span>
                            </div>
                        </div>
                        <div class="o-detail">
                            <div class="o-left-detail">
                                <div class="order-img d-none">
                                    <span *ngFor="let productData of mOrderDetail.product_detail, let i = index"><img
                                            src="{{productData?.imageList && productData?.imageList.length > 0 && productData?.imageList[0]?.path ? productData.imageList[0].path : 'assets/images/default-product.png'}}"
                                            alt="image"></span>
                                </div>
                                <div class="order-content-detail">
                                    <label>{{mOrderDetail?.product_detail[0]?.brand}}</label>
                                    <h4>{{mOrderDetail?.product_detail[0]?.name}}</h4>
                                </div>
                            </div>
                            <div class="qty-detail">
                                <div class="qty-labele">Item(s)</div>
                                <div class="qty-item">{{mOrderDetail?.product_detail?.length}}</div>
                            </div>
                        </div>
                        <div class="more-and-btn" >
                            <div class="see-more" *ngIf="mOrderDetail?.product_detail?.length > 1">
                                <span>+{{mOrderDetail?.product_detail?.length - 1}}more</span>
                            </div>
                            <div class="o-right-btn">
                                <ul>
                                    <li>
                                        <a (click)="itemDeliveredProcess(mOrderDetail)" class="order-bg-black">Order Details</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="mOrderDetail && mOrderDetail.product_detail && mOrderDetail.product_detail.length > 1">
                        <div class="order-status-and-number">
                            <div class="order-number-and-placed">
                                <div class="order-number">
                                    <label>Order Number</label>
                                    <span>{{mOrderDetail.order_number}}</span>
                                </div>
                                <div class="order-place">
                                    <label>Placed</label>
                                    <span>{{showDate(mOrderDetail?.order_date)}}</span>
                                </div>
                            </div>
                            <div class="order-status">
                                <label>Order Status</label>
                                <span *ngIf="mOrderDetail?.order_status == 'cancel'" class="c-orange">Cancelled</span>
                                <span *ngIf="mOrderDetail?.order_status != 'cancel'" class="c-orange">{{mOrderDetail?.order_status}}</span>
                            </div>
                        </div>
                        <div class="o-detail">
                            <div class="order-left-detail">
                                <div *ngIf="mOrderDetail?.order_status == 'pending'" class="delived-item">
                                    {{mOrderDetail?.product_detail?.length}} item(s) in Process</div>
                                <div *ngIf="mOrderDetail?.order_status != 'pending'" class="delived-item">
                                    {{mOrderDetail?.product_detail?.length}} item(s) Delivered</div>
                                <ul>
                                    <li *ngFor="let productData of mOrderDetail.product_detail, let i = index"
                                        [ngClass]="i >= 3 ? 'd-none' : ''">
                                        <span>
                                            <img src="{{productData?.imageList && productData?.imageList.length > 0 && productData?.imageList[0]?.path ? productData.imageList[0].path : 'assets/images/default-product.png'}}"
                                                alt="image" alt="image" />
                                        </span>
                                    </li>
                                    <li *ngIf="mOrderDetail && mOrderDetail.product_detail && mOrderDetail.product_detail.length > 3"
                                        (click)="itemDeliveredProcess(mOrderDetail)">
                                        <div class="more">2+ <br /> more</div>
                                    </li>
                                </ul>
                            </div>
                            <div class="o-right-btn">
                                <ul>
                                    <li>
                                        <a (click)="itemDeliveredProcess(mOrderDetail)" class="order-bg-black">Order Details</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Order Empty States start -->
            <div class="order-empty" *ngIf="this.mOrderDetailListData && this.mOrderDetailListData.length == 0;">
                <div class="empty-text">
                    <span>Looks like You haven’t Ordered Anything Yet! </span>
                    <small>Discover the Right Products FOR YOU now.</small>
                </div>
                <div class="order-btn-shopping" (click)="startShoping()">
                    <a class="start-shopping-btn">Start Shopping</a>
                </div>
            </div>

            <!-- Order Empty States End  -->
        </div>
    </div>
    <div class="order-detail" *ngIf="orderForm">
        <div class="order-title">
            <div class="order-text">
                <h4>Orders details</h4>
            </div>
        </div>
        <div class="order-box-detail">
            <div class="o-number">
                <label>Order Number</label>
                <span>{{mOrderDetail?.order_number}}</span>
            </div>
            <div class="o-number place-on">
                <label>Place On</label>
                <span>{{showDate(mOrderDetail?.order_date)}}</span>
            </div>
            <div class="o-number total">
                <label>Total</label>
                <span>₹{{mOrderDetail?.order_amount}}</span>
            </div>
        </div>
        <div class="shipping-detail">
            <h4>Shipping Address</h4>
            <div class="shipping-name">{{mOrderDetail?.customer_detail?.first_name}}</div>
            <address>{{mOrderDetail?.user_address}}</address>
        </div>
        <div *ngIf="mOrderDetail && mOrderDetail.product_detail && mOrderDetail.product_detail.length > 0">
            <div class="shipment-detail" *ngFor="let product of mOrderDetail.product_detail; let i = index;">
                <div class="shipment-content">
                    <span class="shipment-item">Shipment 0 0f {{product?.product_qty}}</span>
                    <div class="package-delivered">Your package will be delivered within</div>
                    <div class="package-delivered-date">5-6 working days</div>      
                </div>
                <div class="o-detail o-detail-mobile ">
                    <div class="o-left-detail">
                        <div class="order-img">
                            <span>
                                <img src="{{product.imageList && product.imageList.length > 0 && product.imageList[0].path ? product.imageList[0].path : 'assets/images/default-product.png'}}"
                                    alt="image" />
                            </span>
                        </div>
                        <div class="order-content-detail">
                            <span>{{product?.brand}}</span>
                            <h4>{{product?.name}}</h4>
                            <div class="qty-label">Qty</div>
                            <div class="qty-item">{{product?.product_qty}}</div>
                        </div>
                    </div>
                    <div class="o-right-btn">
                        <div class="total-line-through" *ngIf="product?.discountAppliedAmount && !showDiscountOnTotal">₹{{calculateIndividualTotal(product?.product_qty
                            || 1, product?.your_price)}}</div>
                        <div class="total-price"  *ngIf="product?.discountAppliedAmount && product?.discountType == 'fix' && !showDiscountOnTotal">₹{{product?.discountAppliedAmount}}</div>
                        <div class="total-price"  *ngIf="product?.discountAppliedAmount && product?.discountType == 'percentage' && !showDiscountOnTotal">₹{{product?.discountAppliedAmount}}</div>

                        <div class="total-price"  *ngIf="!product?.discountAppliedAmount && !showDiscountOnTotal">₹{{calculateIndividualTotal(product?.product_qty
                                || 1, product?.your_price)}}</div>

                        <div class="total-price" *ngIf="showDiscountOnTotal">
                            <span>₹{{calculateIndividualTotal(product?.product_qty || 1,
                                product?.your_price)}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="cancel-and-track-order">
            <ul>
                <li *ngIf="mOrderDetail?.order_status == 'delivered'">
                    <a href="https://forms.gle/BF71Yd6H1HwRN1787" target="_blank" class="return-btn">return & Exchange</a>
                </li>
                <li *ngIf="mOrderDetail?.order_status != 'cancel' && mOrderDetail?.order_status != 'Cancelled'"><a data-bs-toggle="modal"
                        data-bs-target="#confirmation" (click)="cancelOrder(mOrderDetail)" class="cancel-border">cancel
                        order</a></li>
                <li *ngIf="mOrderDetail?.order_status == 'cancel' || mOrderDetail?.order_status == 'Cancelled'"><a class="cancel-border">Cancelled</a></li>
                <li class="need-help-link">
                    <a (click)="redirectToNeedHelp()">
                        Need Help?
                        <img src="assets/images/order-right-arrow.png" alt="arrow" />
                    </a>
                </li>
            </ul>
        </div>
        <div class="payment-method-detail">
            <h4>Payment Detail</h4>
            <div class="p-detail">
                <label>Payment method</label>
                <span>{{mOrderDetail?.cod == true? 'COD': 'ONLINE'}}</span>
            </div>
            <div class="p-detail">
                <label>Subtotal (Inclusive Tax)</label>
                <span>₹{{subTotalInclusiveTax}}</span>
            </div>
            <div class="p-detail" *ngIf="mOrderDetail?.total_discount_amount > 0">
                <label>Discount</label>
                <span> <small>(-)</small> ₹{{mOrderDetail?.total_discount_amount}}</span>
            </div>
            <div class="p-detail">
                <label>Shipping Charges</label>
                <span>₹{{mOrderDetail?.shipping_charge}}</span>
            </div>
            <div class="p-detail p-total">
                <label>Total:</label>
                <span>₹{{mOrderDetail?.order_amount}}</span>
            </div>
        </div>
        <div class="total-saving">
            <label>Total Savings:</label>
            <span>₹{{mOrderDetail?.total_discount_amount}}</span>
        </div>
    </div>
</div>

<div class="modal fade modal-add-contact" id="confirmation" tabindex="-1" role="dialog">
    <app-confirmation [id]="id" [deleteType]="deleteType" (saveClick)="getOrderList('cancel')"></app-confirmation>
</div>